import "./App.css"
import { useEffect, useState } from "react"
import PreLoader from "./components/pre-loader/PreLoader"
import Header from "./components/header/Header"
import Hero from "./components/hero-section/Hero"
import Services from "./components/services/Services"
// import Gallery from './components/gallery/Gallery';
import About from "./components/about/About"
import Contact from "./components/contact/Contact"
import Quote from "./components/quote/Quote"
import Ticket from "./components/ticket/ticket/Ticket"
import Footer from "./components/footer/Footer"
import TransitionOverlay from "./components/transition-overlay/TransitionOverlay"

import { Routes, Route, useLocation } from "react-router-dom"

import { LoadScript } from "@react-google-maps/api"
import { TransitionProvider } from "./contexts/TransitionContext"

const libraries = ["places"]
const googleMapsPublicKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY

const Home = () => {
    return (
        <>
            <Services />
            <About />
            <Contact />
        </>
    )
}

function App() {
    const location = useLocation()

    if ("scrollRestoration" in window.history) {
        window.history.scrollRestoration = "manual" // Disable default scroll restoration
    }

    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        const disableScroll = (event) => event.preventDefault()

        if (isLoading) {
            window.addEventListener("wheel", disableScroll, { passive: false })
            window.addEventListener("touchmove", disableScroll, {
                passive: false,
            })
        } else {
            window.removeEventListener("wheel", disableScroll)
            window.removeEventListener("touchmove", disableScroll)
        }
        return () => {
            window.removeEventListener("wheel", disableScroll)
            window.removeEventListener("touchmove", disableScroll)
        }
    }, [isLoading])

    useEffect(() => {
        const timeout = setTimeout(() => {
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        const title = entry.target.querySelector("span")
                        if (entry.isIntersecting) {
                            title?.classList.add("show")
                        } else {
                            title?.classList.remove("show")
                        }
                    })
                },
                { threshold: 0.3 },
            )
            const sections = document.querySelectorAll(".section .title")
            sections.forEach((section) => observer.observe(section))
            return () => {
                sections.forEach((section) => observer.unobserve(section))
            }
        }, 100)

        return () => clearTimeout(timeout)
    }, [location.pathname])

    return (
        <TransitionProvider>
            <LoadScript
                googleMapsApiKey={googleMapsPublicKey}
                libraries={libraries}
                loadingElement={<></>}
            >
                <TransitionOverlay />
                <div className="app-container">
                    <PreLoader isLoading={isLoading} />
                    <Header isLoading={isLoading} />
                    <Hero isLoading={isLoading} setIsLoading={setIsLoading} />
                    <Routes>
                        <Route path="/ticket/*" element={<Ticket />} />
                        <Route path="/quote" element={<Quote />} />
                        <Route path="*" element={<Home />} />
                    </Routes>
                    <Footer />
                </div>
            </LoadScript>
        </TransitionProvider>
    )
}

export default App
